module.exports = __webpack_public_path__ + "static/media/searchIconDark.8b930784.svg";